import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

import "./Menu.css";
const Menu = () => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isEnVisible, setEnVisible] = useState(false);
  const [isAboutVisible, setAboutVisible] = useState(false);
  const [isCustomerVisible, setCustomerVisible] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };
  const toggleDropdownEn = () => {
    setEnVisible(!isEnVisible);
  };
  const toggleDropdownAbout = () => {
    setAboutVisible(!isAboutVisible);
  };
  const toggleDropdownCustomer = () => {
    setCustomerVisible(!isCustomerVisible);
  };
  return (
    <div>
      {" "}
      <div className="menu for-main-page">
        <div className="main-content">
          <div className="logo-wrapper">
            <img
              className="logo"
              src="https://www.zazmic.com/wp-content/themes/zazmic/img/logo.svg"
              alt="logo"
            />
            {/* <img className="logo-small" src="https://www.zazmic.com/wp-content/themes/zazmic/img/logo-small.svg"
            alt="logo" /> */}
          </div>
          <div id="header-menu" className="header-menu">
            <nav id="site-navigation" className="main-navigation">
              <div className="menu-menu-1-container">
                <ul id="primary-menu" className="menu">
                  <a href="https://www.zazmic.com/expertise/">
                    {" "}
                    <li id="menu-item" className="menu-item">
                      Expertise
                    </li>
                  </a>
                  <li className="menu-item" id="dropdown-menu">
                    <div
                      to="/"
                      className="dropdown-toggle"
                      onClick={toggleDropdown}
                    >
                      Cloud
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className={`sub-menu ${
                          isDropdownVisible ? "rotate-icon rotate180" : ""
                        }`}
                        id="svg__icon"
                      />
                    </div>
                    {isDropdownVisible && (
                      <ul className="dropdown-content">
                        <a href="https://www.zazmic.com/solution-packages/">
                          <li id="menu-item" className="menu-item">
                            Packages
                          </li>
                        </a>
                        <a href="https://www.zazmic.com/specialization/">
                          <li id="menu-item" className="menu-item">
                            Specialization
                          </li>
                        </a>
                        <a href="https://www.zazmic.com/ai-workshops/">
                          <li id="menu-item" className="menu-item">
                            AI Workshops
                          </li>
                        </a>
                      </ul>
                    )}
                  </li>
                  <li className="menu-item" id="dropdown-menu">
                    <div
                      to="/"
                      className="dropdown-toggle"
                      onClick={toggleDropdownCustomer}
                    >
                      Customers
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className={`sub-menu ${
                          isCustomerVisible ? "rotate-icon rotate180" : ""
                        }`}
                        id="svg__icon"
                      />
                    </div>
                    {isCustomerVisible && (
                      <ul className="dropdown-content">
                        <a href="https://www.zazmic.com/portfolio/">
                          <li id="menu-item" className="menu-item">
                          Clients Portfolio
                          </li>
                        </a>
                      
                      </ul>
                    )}
                  </li>
                  <a href="https://www.zazmic.com/zazmic-partners/">
                    <li id="menu-item" className="menu-item">
                      Partners
                    </li>
                  </a>
                  <a href="https://www.zazmic.com/blog/">
                    <li id="menu-item" className="menu-item">
                      Blog
                    </li>
                  </a>
                  <li className="menu-item" id="dropdown-menu">
                    <div
                      className="dropdown-toggle"
                      onClick={toggleDropdownAbout}
                    >
                      About Us{" "}
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className={`sub-menu ${
                          isAboutVisible ? "rotate-icon rotate180" : ""
                        }`}
                        id="svg__icon"
                      />
                    </div>
                    {isAboutVisible && (
                      <ul className="dropdown-content">
                      <a href="https://www.zazmic.com/who-we-are/"> <li id="menu-item" className="menu-item">
                          Who we are
                        </li></a> 
                        <a href="https://www.zazmic.com/culture/"><li id="menu-item" className="menu-item">
                          Culture
                        </li></a> 
                        <a href="https://www.zazmic.com/vacancies/"> <li id="menu-item" className="menu-item">
                          Careers
                        </li></a> 
                      </ul>
                    )}
                  </li>
                  <a href="https://www.zazmic.com/contact-us/"> 
                  <li id="menu-item" className="menu-item">
                    Contact Us
                  </li></a> 
                  <a href="https://portal.zazmic.com/signin"> 
                  <li id="menu-item" className="menu-item">
                    Login
                  </li></a> 
                  <li className="menu-item" id="dropdown-menu">
                    <div className="dropdown-toggle" onClick={toggleDropdownEn}>
                      EN{" "}
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className={`sub-menu ${
                          isEnVisible ? "rotate-icon rotate180" : ""
                        }`}
                        id="svg__icon"
                      />
                    </div>
                    {isEnVisible && (
                      <ul className="dropdown-content">
                      <a href="https://www.zazmic.com/es/home-page-espanol/"> <li id="menu-item" className="menu-item">
                          ES
                        </li></a> 
                        <a href="https://www.zazmic.com/pt/home-pt/"> <li id="menu-item" className="menu-item">
                          PT
                        </li></a> 
                      </ul>
                    )}
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
